import type { MasterProductAttribute } from './types';

// Shared EAV <-> per-type-multi-value conversion, used by both the
// family-workspace variants grid (row-helpers.ts) and the quote-matcher's
// VariantFormModal — keep them in sync rather than duplicating the reduce.

// Groups flat EAV rows into per-type value lists. Collects ALL values per
// type (not first-wins), deduped by exact value, preserving first-seen order.
export function groupAttributesByType(attributes: MasterProductAttribute[] | undefined): Record<string, string[]> {
  return (attributes ?? []).reduce<Record<string, string[]>>((acc, a) => {
    const list = acc[a.attributeType] ?? (acc[a.attributeType] = []);
    if (!list.includes(a.attributeValue)) list.push(a.attributeValue);
    return acc;
  }, {});
}

// Flattens a per-type value-list record back to one EAV entry per
// (type, value) pair, for the bulk-upsert / create / update payloads.
export function flattenAttributes(attributes: Record<string, string[]>): MasterProductAttribute[] {
  return Object.entries(attributes).flatMap(([attributeType, values]) =>
    values.map((attributeValue) => ({ attributeType, attributeValue }))
  );
}
